import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

type MarketplaceDriverFunction = (
  marketplaceEntity: MarketplaceEntity,
  ...opts: Array<unknown>
) => MarketplaceDriverConfig | null | undefined;

const isPresent = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined;
};

export const makeDrivers =
  (driverFunctions: Array<MarketplaceDriverFunction>) =>
  (
    marketplaceEntity: MarketplaceEntity,
    ...opts: Array<unknown>
  ): Array<MarketplaceDriverConfig> => {
    const mappedDrivers = driverFunctions
      .map(driverFunction => {
        const marketplaceDriver = driverFunction(marketplaceEntity, ...opts);
        return marketplaceDriver;
      })
      .filter(isPresent);
    return mappedDrivers;
  };
